import { render } from "./AddImagePatient.vue?vue&type=template&id=256bf230&ts=true"
import script from "./AddImagePatient.vue?vue&type=script&lang=ts"
export * from "./AddImagePatient.vue?vue&type=script&lang=ts"

import "./AddImagePatient.vue?vue&type=style&index=0&id=256bf230&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo_YHCT/ZaloOA_CLS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__